<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 24 24"
    class="icon-edit"
    :class="[`icon-edit--color-${color}`]"
  >
    <path
      d="M20.71,7.04C21.1,6.65 21.1,6 20.71,5.63L18.37,3.29C18,2.9 17.35,2.9 16.96,3.29L15.12,5.12L18.87,8.87M3,17.25V21H6.75L17.81,9.93L14.06,6.18L3,17.25Z"
    />
  </svg>
</template>

<script>
  export default {
    name: 'IconEdit',
    props: {
      color: {
        type: String,
        default: 'white',
        validator: (value) =>
          ['white', 'black', 'grey', 'blue'].includes(value),
      },
      width: {
        type: [Number, String],
        default: 24,
      },
      height: {
        type: [Number, String],
        default: 24,
      },
    },
  };
</script>

<style lang="scss" scoped>
  .icon-edit {
    fill: currentColor;

    &--color-white {
      fill: #ffffff;
    }
    &--color-black {
      fill: #000000;
    }
    &--color-grey {
      fill: #a7a9ab;
    }
    &--color-blue {
      fill: #17355c;
    }
  }
</style>
